module.exports = __webpack_public_path__ + "static/media/pocket-kit-brush.15efc05b.png";